<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Accordion" pageTitle="Accordion" />
            <AccordionContent />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import AccordionContent from '../Accordion/AccordionContent'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'AccordionPage',
    components: {
        MainHeader,
        PageTitle,
        AccordionContent,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>